import { DateTime } from 'luxon'
const dayjs = require('dayjs');

// Function to convert date string to the custom object
export function dateStringToCustomObject(dateString) {
  const dayjsObject = dayjs(dateString);
  return {
    $D: dayjsObject.date(),
    $H: dayjsObject.hour(),
    $L: dayjsObject.locale(),
    $M: dayjsObject.month(),
    $W: dayjsObject.day(),
    $d: dayjsObject.toDate(),
    $isDayjsObject: true,
    $m: dayjsObject.minute(),
    $ms: dayjsObject.millisecond(),
    $s: dayjsObject.second(),
    $u: undefined,
    $x: {},
    $y: dayjsObject.year(),
  };
}
export function customObjectToDateString(customObject) {
  const { $y, $M, $D } = customObject;
  // Recreate a Day.js object from the custom object
  const date = dayjs().set('year', $y).set('month', $M).set('date', $D);
  // Format the date string in "YYYY-MM-DD" format
  return date.format('YYYY-MM-DD');
}
export function formatDateToYYYYMMDD(dateInput) {
  const date = new Date(dateInput);

  // Validate the date by checking if it's a valid date object
  if (isNaN(date.getTime())) {
    return null; // If the date is invalid, return null
  }

  return date.toISOString().split('T')[0]; // Extract and return YYYY-MM-DD
}
export function convertToVaTime(timeStr) {
  // Check if the input is a valid time string (HH:MM:SS)
  const timePattern = /^([01]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])$/;
  
  // Return null if the time format is invalid
  if (!timePattern.test(timeStr)) {
    return null;
  }

  // Split the time into hours, minutes, and seconds
  const [hours, minutes, seconds] = timeStr.split(':');
  
  let hour = parseInt(hours, 10);
  const minute = minutes;
  let period = 'AM';

  // Convert to 12-hour format
  if (hour >= 12) {
    period = 'PM';
    if (hour > 12) {
      hour -= 12; // Convert hours greater than 12 to 12-hour format
    }
  } else if (hour === 0) {
    hour = 12; // Midnight is 12 AM
  }

  // Format the time to 12-hour format with AM/PM
  const formattedTime = `${hour}:${minute} ${period}`;
  return formattedTime;
}

// // Example usage
// const customObj = dateStringToCustomObject('2024-10-24');
// console.log(customObj);

// const dateString = customObjectToDateString(customObj);
// console.log(dateString);
export function convertTimestampToFormattedString(timestamp) {
  try {
    const date = new Date(timestamp);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Return empty if the timestamp is invalid
    }

    // Define an array for weekday and month names
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Extract the day of the week, month, and day of the month
    const weekday = weekdays[date.getDay()];
    const month = months[date.getMonth()];
    const day = date.getDate();

    // Format the result
    return `${weekday}, ${month} ${day}`;
  } catch (error) {
    return ""; // Return empty in case of unexpected errors
  }
}

export   const formatmuiDate = (date) => {
  const dt = DateTime.fromJSDate(date); // Convert to luxon DateTime object
  return {
    $L: 'en',  // Locale
    $u: undefined,
    $d: dt.toJSDate(),  // Convert back to native JS Date
    $y: dt.year, // Year
    $M: dt.month - 1, // Month (luxon is 1-based, so subtract 1 for zero-based month)
    $d: dt.day, // Day of the month
    $h: dt.hour, // Hour
    $m: dt.minute, // Minute
    $s: dt.second, // Second
    $z: dt.zoneName, // Timezone
  };
};